export default __webpack_public_path__ + "static/media/books.af35e77d.png";